import { authHeader } from "./auth-header";
import { retryAfterSeconds } from "@/utils/retryAfter";
var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function(cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function(jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export const userService = {
  verifyLoginCode,
  login,
  logout,
  userEntities,
  register,
  getAll,
};

function verifyLoginCode(code) {
  const data = { code };
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(process.env.VUE_APP_BASE_URL + `/api/verify-login-code`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // console.log('verifyLoginCode', user);
      if (user.data.access_token) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      return user;
    });
}

function login(email, password , code = '') {
  const key = localStorage.getItem('serverId');
  password = btoa(CryptoJS.AES.encrypt(
    JSON.stringify(password),
    key,
    { format: CryptoJSAesJson }
  ).toString());
  
  const data = { email, password };
  if (code) data.code = code;
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(process.env.VUE_APP_BASE_URL + `/api/login`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      if (user.data.access_token) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      return user;
    });
}

function userEntities(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    process.env.VUE_APP_BASE_URL + `/api/users_entities/` + id,
    requestOptions
  ).then(handleResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

function register(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(user),
  };
  return fetch(
    process.env.VUE_APP_BASE_URL + `/api/register`,
    requestOptions
  ).then(handleResponse);
}

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }
      if (response.status === 422) {
        localStorage.setItem("errors", JSON.stringify(data));
      }
      // Reject with the status and, for a 429, the wait in seconds. Callers
      // used to get a bare message string, which left them no way to tell the
      // user when they could try again (CL-17932).
      return Promise.reject({
        status: response.status,
        message: (data && data.message) || response.statusText,
        retryAfter: retryAfterSeconds({ status: response.status, data, headers: response.headers }),
      });
    }
    return data;
  });
}
